export const MOBILITY_GARAGE_USER_TYPES = [1, 2, 3];

export const getGarageStatus = (garage) => {
  const status = garage?.status;
  if (!status) return "";
  if (typeof status === "string") return status.trim();
  return String(status.key || status.name || "").trim();
};

export const normalizeGarageStatus = (status) =>
  getGarageStatus({ status }).toLowerCase();

export const isMobilityGarageUser = (userType) =>
  MOBILITY_GARAGE_USER_TYPES.includes(Number(userType));

export const isGarageActiveOrUnderMonitoring = (garage) => {
  const status = normalizeGarageStatus(getGarageStatus(garage));
  return status === "active" || status === "under monitoring";
};

export const getGarageStatusChipStyle = (status) => {
  const normalized = normalizeGarageStatus(status);

  switch (normalized) {
    case "active":
      return { backgroundColor: "#28A745", color: "#fff" };
    case "under monitoring":
      return { backgroundColor: "#F57C00", color: "#fff" };
    case "suspended":
      return { backgroundColor: "#E33C30", color: "#fff" };
    case "blacklisted":
      return { backgroundColor: "#000000", color: "#fff" };
    default:
      return { backgroundColor: "#9e9e9e", color: "#fff" };
  }
};

export const isGarageRestricted = (garage) =>
  !isGarageActiveOrUnderMonitoring(garage);

export const filterGaragesForMobility = (garages = []) =>
  garages.filter(isGarageActiveOrUnderMonitoring);

export const buildGarageMarkerIcon = (restricted) => {
  const html = restricted
    ? `<div style="position:relative;display:inline-block;">
        <img src='/assets/category/default/garagetop.svg' alt='' style="filter:blur(1px) grayscale(50%);opacity:0.7;" />
        <span style="position:absolute;top:-2px;right:-6px;background:#E33C30;color:#fff;border-radius:50%;width:18px;height:18px;font-size:12px;line-height:18px;text-align:center;font-weight:700;box-shadow:0 0 0 1px #fff;">!</span>
      </div>`
    : `<img src='/assets/category/default/garagetop.svg' alt='' />`;

  return {
    iconUrl: "/assets/category/default/garagetop.svg",
    iconSize: [50, 50],
    iconAnchor: [25, 25],
    tooltipAnchor: [0, -20],
    className: restricted
      ? "custom-marker garage-marker-restricted"
      : "custom-marker",
    html,
  };
};
